import { FieldOption } from '@nagel-types';
import parsePhoneNumberFromString, { getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js';

export const DRIVER_COUNTRY_CODE_OPTIONS: FieldOption[] = [
    { value: '+355', viewValue: $localize`Albania: +355` },
    { value: '+376', viewValue: $localize`Andorra: +376` },
    { value: '+375', viewValue: $localize`Belarus (Weißrussland): +375` },
    { value: '+32', viewValue: $localize`Belgium: +32` },
    { value: '+387', viewValue: $localize`Bosnia and Herzegovina: +387` },
    { value: '+359', viewValue: $localize`Bulgaria: +359` },
    { value: '+45', viewValue: $localize`Denmark: +45` },
    { value: '+49', viewValue: $localize`Germany: +49` },
    { value: '+372', viewValue: $localize`Estonia: +372` },
    { value: '+298', viewValue: $localize`Faroe Islands: +298` },
    { value: '+358', viewValue: $localize`Finland: +358` },
    { value: '+33', viewValue: $localize`France: +33` },
    { value: '+350', viewValue: $localize`Gibraltar: +350` },
    { value: '+30', viewValue: $localize`Greece: +30` },
    { value: '+44', viewValue: $localize`United Kingdom: +44` },
    { value: '+353', viewValue: $localize`Ireland: +353` },
    { value: '+354', viewValue: $localize`Iceland: +354` },
    { value: '+39', viewValue: $localize`Italy: +39` },
    { value: '+383', viewValue: $localize`Kosovo: +383` },
    { value: '+385', viewValue: $localize`Croatia: +385` },
    { value: '+371', viewValue: $localize`Latvia: +371` },
    { value: '+423', viewValue: $localize`Liechtenstein: +423` },
    { value: '+370', viewValue: $localize`Lithuania: +370` },
    { value: '+352', viewValue: $localize`Luxembourg: +352` },
    { value: '+356', viewValue: $localize`Malta: +356` },
    { value: '+389', viewValue: $localize`North Macedonia: +389` },
    { value: '+373', viewValue: $localize`Moldova: +373` },
    { value: '+377', viewValue: $localize`Monaco: +377` },
    { value: '+382', viewValue: $localize`Montenegro: +382` },
    { value: '+31', viewValue: $localize`Netherlands: +31` },
    { value: '+47', viewValue: $localize`Norway: +47` },
    { value: '+43', viewValue: $localize`Austria: +43` },
    { value: '+48', viewValue: $localize`Poland: +48` },
    { value: '+351', viewValue: $localize`Portugal: +351` },
    { value: '+40', viewValue: $localize`Romania: +40` },
    { value: '+378', viewValue: $localize`San Marino: +378` },
    { value: '+46', viewValue: $localize`Sweden: +46` },
    { value: '+41', viewValue: $localize`Switzerland: +41` },
    { value: '+381', viewValue: $localize`Serbia: +381` },
    { value: '+421', viewValue: $localize`Slovakia: +421` },
    { value: '+386', viewValue: $localize`Slovenia: +386` },
    { value: '+34', viewValue: $localize`Spain: +34` },
    { value: '+420', viewValue: $localize`Czech Republic: +420` },
    { value: '+90', viewValue: $localize`Turkey: +90` },
    { value: '+380', viewValue: $localize`Ukraine: +380` },
    { value: '+36', viewValue: $localize`Hungary: +36` }
];

export const getParseTelephoneNumberAndCode = (phoneNumber: string) => {
    let phoneNumberToProcess = getPhoneWithPlusSign(phoneNumber || '');

    const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumberToProcess || '');
    let countryCode = '';
    let processedNationalNumber = phoneNumber || '';

    const { countryCallingCode, nationalNumber } = parsedPhoneNumber || {};

    if (parsedPhoneNumber) {
        let countryCodeToValidate = getPhoneWithPlusSign(countryCallingCode || '');

        countryCode = countryCallingCode && getIsValidCountryCode(countryCodeToValidate)
            ? countryCodeToValidate
            : '';

        if (countryCode) {
            processedNationalNumber = nationalNumber || '';
        }
    }

    return { countryCode, nationalNumber: processedNationalNumber };
};

const getPhoneWithPlusSign = (phone: string) => {
    let result = phone;

    if (!result.includes('+')) {
        result = `+${result}`;
    }

    return result;
};

export const getPhoneOptionByCountryCode = (countryCode: string): FieldOption | undefined => {
    return DRIVER_COUNTRY_CODE_OPTIONS.find(option => option.value === countryCode);
};

export const getIsValidCountryCode = (countryCodeValue: string): boolean => {
    return DRIVER_COUNTRY_CODE_OPTIONS.map((option) => option.value).includes(countryCodeValue);
};

export const getCountryCodeForIsoCountry = (isoCountry: string): string => {
    let result = '';

    if (isSupportedCountry(isoCountry)) {
        result = getCountryCallingCode(isoCountry);
    }
    return result;
};
